import React, { useState } from 'react';
import { styled } from 'linaria/react';
import { useQuery } from 'react-apollo';
import PackageProductNewQuery from './PackageProductNewQuery.gql';
import { Link } from 'react-router-dom';

const PackageProductWrapper = styled('div')`
  padding-bottom: 12px;
`;

const PackageProductInfoWrapper = styled('div')`
  display: flex;
  flex-direction: column;

  span {
    color: #000;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    margin-bottom: 4px;
  }

  .package-product-items-wrapper {
    list-style-type: none;
    padding: 0;
    margin: 0 0 10px 0;

    li:nth-child(even) {
      background: #fff;
    }
    li:nth-child(odd) {
      background: #fdfbf8;
    }

    a {
      text-decoration: none;
      display: flex;
      justify-content: space-between;
      color: #000;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
    }
  }
`;

const ExpandButton = styled('div')`
  color: #000;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-decoration-line: underline;
  cursor: pointer;
`;

export function PackageProductNew({ product }) {
  const [expanded, setExpanded] = useState(false);
  const packageProduct = product?.customFields?.find(
    ({ key }) => key === 'paket'
  );

  const { data, loading } = useQuery(PackageProductNewQuery, {
    variables: {
      articles: packageProduct?.listValues,
    },
    errorPolicy: 'all',
  });

  return (
    <PackageProductWrapper>
      {expanded ? (
        <PackageProductInfoWrapper>
          <span>Paketet innehåller:</span>
          <ul className="package-product-items-wrapper">
            <>
              {data?.products?.map((product, index) => {
                return (
                  <li key={index}>
                    <Link to={product?.primaryRoute?.path}>
                      {product.name}
                      <span>{product.price.incVat} kr</span>
                    </Link>
                  </li>
                );
              })}
            </>
          </ul>
          <ExpandButton onClick={() => setExpanded(!expanded)}>
            - Fäll ihop
          </ExpandButton>
        </PackageProductInfoWrapper>
      ) : (
        <ExpandButton onClick={() => setExpanded(!expanded)}>
          + Se vad som ingår i paketet
        </ExpandButton>
      )}
    </PackageProductWrapper>
  );
}
